import { useEffect, useState } from 'react';
import { api } from '../api';

export default function Fornecedores() {
  const [lista, setLista] = useState([]);
  const [novo, setNovo] = useState({ nome: '', contato: '' });
  const [edit, setEdit] = useState(null); // { id, nome, contato, observacoes }
  const [erro, setErro] = useState('');

  const carregar = () => { api('/fornecedores').then(setLista).catch(e => setErro(e.message)); };
  useEffect(() => { carregar(); }, []);

  const criar = async () => {
    if (!novo.nome.trim()) return;
    try {
      await api('/fornecedores', { method: 'POST', body: novo });
      setNovo({ nome: '', contato: '' });
      carregar();
    } catch (e) { setErro(e.message); }
  };

  const salvarEdicao = async () => {
    if (!edit.nome.trim()) return setErro('O nome não pode ficar vazio.');
    try {
      await api(`/fornecedores/${edit.id}`, {
        method: 'PATCH',
        body: { nome: edit.nome.trim(), contato: edit.contato, observacoes: edit.observacoes },
      });
      setEdit(null);
      carregar();
    } catch (e) { setErro(e.message); }
  };

  const toggle = async f => {
    try { await api(`/fornecedores/${f.id}`, { method: 'PATCH', body: { ativo: !f.ativo } }); carregar(); }
    catch (e) { setErro(e.message); }
  };

  return (
    <div>
      <h2 style={{ marginBottom: 14 }}>Fornecedores de Lentes</h2>
      {erro && <div className="erro" style={{ marginBottom: 12 }}>{erro}</div>}

      {edit && (
        <div className="card" style={{ background: 'var(--verde-claro)', marginBottom: 14 }}>
          <div className="row">
            <div style={{ flex: 2 }}><label className="label">Nome</label>
              <input className="input" autoFocus value={edit.nome}
                onChange={e => setEdit({ ...edit, nome: e.target.value })} /></div>
            <div style={{ flex: 2 }}><label className="label">Contato</label>
              <input className="input" value={edit.contato || ''}
                onChange={e => setEdit({ ...edit, contato: e.target.value })} /></div>
          </div>
          <div style={{ marginTop: 8 }}>
            <label className="label">Observações</label>
            <textarea className="textarea" rows={2} value={edit.observacoes || ''}
              onChange={e => setEdit({ ...edit, observacoes: e.target.value })}
              placeholder="Ex.: exige foto da armação; prazo médio 5 dias úteis" />
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <button className="btn" onClick={salvarEdicao}>Salvar alterações</button>
            <button className="btn-sec" onClick={() => setEdit(null)}>Cancelar</button>
          </div>
        </div>
      )}

      <div className="card">
        <div className="row" style={{ marginBottom: 14 }}>
          <input className="input" style={{ flex: 2 }} placeholder="Nome do fornecedor (ex.: Zeiss, Smart Lab)"
            value={novo.nome} onChange={e => setNovo({ ...novo, nome: e.target.value })} />
          <input className="input" style={{ flex: 2 }} placeholder="Contato (telefone, e-mail, representante)"
            value={novo.contato} onChange={e => setNovo({ ...novo, contato: e.target.value })} />
          <button className="btn" onClick={criar}>+ Cadastrar</button>
        </div>
        <table className="tbl">
          <thead><tr><th>Fornecedor</th><th>Contato</th><th>OS vinculadas</th><th>Situação</th><th></th></tr></thead>
          <tbody>
            {lista.map(f => (
              <tr key={f.id} style={{ opacity: f.ativo ? 1 : .45 }}>
                <td>
                  <div style={{ fontWeight: 700 }}>{f.nome}</div>
                  {f.observacoes && <div style={{ fontSize: 11.5, color: 'var(--cinza)' }}>{f.observacoes}</div>}
                </td>
                <td>{f.contato || '—'}</td>
                <td>{f.total_os}</td>
                <td>
                  <span className="badge" style={f.ativo
                    ? { background: '#e2f3e8', color: 'var(--ok)' }
                    : { background: '#eef1f2', color: 'var(--cinza)' }}>
                    {f.ativo ? 'Ativo' : 'Inativo'}
                  </span>
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <button className="btn-sec" style={{ marginRight: 6 }}
                    onClick={() => setEdit({ id: f.id, nome: f.nome, contato: f.contato, observacoes: f.observacoes })}>
                    Editar
                  </button>
                  <button className="btn-sec" onClick={() => toggle(f)}>{f.ativo ? 'Desativar' : 'Ativar'}</button>
                </td>
              </tr>
            ))}
            {!lista.length && <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--cinza)' }}>Nenhum fornecedor cadastrado.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
